import ModuleContentActions from './ModuleContentActions';

export default ModuleContentActions;
